<template>
  <div>
    <h1 class="scroll-border-dom">{{$t('aboutus.title')}}</h1>
    <section>
      <p style="margin-bottom: 12px;">“O-TECH”系统是由上海科橘信息科技有限公司自主研发的、拥有独立知识产权的自由贸易协定优惠关税应用系统。</p>
      <p>“O-TECH”系统旨在为企业尤其是中小企业解决FTA优惠关税的信息查询及应用问题。通过该系统，企业可以简易快捷地了解到哪些进出口商品可以享受零关税，以及如何享受零关税，提高企业在FTA优惠关税方面的利用能力。</p>
    </section>
    <h1 style="margin-top: 35px;">{{$t('aboutus.title2')}}</h1>
    <section style="margin-bottom:15px">
      <p>同时，“O-TECH”还提供完备的线下服务，与线上服务共同塑造全方位的一站式体验，以协助企业以最优方式运用FTA优惠关税系统。“O-TECH”线下服务包括：</p>
    </section>
    <ul class="ofl">
      <li>
        <div class="sn">1</div>
        <div class="title">合规管理</div>
        <div class="desc">为企业提供综合的贸易合规管理解决方案；</div>
      </li>
      <li>
        <div class="sn">2</div>
        <div class="title">业务咨询</div>
        <div class="desc">为企业提供一对一咨询，根据企业自身需求特点，提供量身定制的贸易咨询服务，包括关税筹划、预裁定申请、流程梳理、政策解读等；</div>
      </li>
      <li>
        <div class="sn">3</div>
        <div class="title">专业培训</div>
        <div class="desc">为企业和相关从业人员提供FTA相关专业培训；</div>
      </li>
      <li>
        <div class="sn">4</div>
        <div class="title">磋商协助</div>
        <div class="desc">如果企业在申请FTA优惠待遇时发生困难，可以协助企业与监管部门进行磋商和沟通，以便企业享受优惠待遇；帮助企业在海关稽查和缉私过程中处理相关问题。</div>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'AboutContent'
}
</script>
<style scoped>
  h1{
    font-size: 16px;
    color: #333;
    margin: 25px 0 15px;
  }
  section{
    color: #333;
    font-size: 14px;
    margin-bottom: 25px;
  }
  section p{
    margin-bottom: 2px;
    line-height: 22px;
  }
  ul li{
    margin-bottom: 25px;
    background: url("~@/assets/images/icons/about/1.png") 0 2px no-repeat transparent;
    background-size: 20px auto;
    padding-left: 35px;
  }
  ul li.i2{
    background-image: url("~@/assets/images/icons/about/2.png");
  }
  ul li.i3{
    background-image: url("~@/assets/images/icons/about/3.png");
  }
  ul.ofl li{
    background-image: none;
    position: relative;
  }
  ul.ofl li .sn{
    background-color: #2681FF;
    width: 16px;
    height: 16px;
    border-radius: 100px;
    color: #fff;
    text-align: center;
    line-height: 16px;
    font-size: 11px;
    position: absolute;
    top: 3px;
    left: 0;
  }
  ul li .title{
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 6px;
    color: #333;
  }
  ul li .desc{
    color: #333;
    font-size: 14px;
    line-height: 22px;
  }
</style>



// WEBPACK FOOTER //
// src/components/about/zh-CN/Content.vue